var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "comments" },
    [
      _c(
        "shadow-scroll-container",
        {
          ref: "scroll",
          staticClass: "comments-tree",
          attrs: { id: "comments-tree" },
        },
        [
          _c("comments-tree", {
            attrs: {
              entity: _vm.entity,
              "entity-id": _vm.entityId,
              comments: _vm.comments,
              "can-edit": _vm.canEdit,
              "active-form": _vm.activeForm,
            },
            on: {
              formOpened: _vm.onFormOpened,
              commentAdded: _vm.onCommentAdded,
              commentUpdated: _vm.onCommentUpdated,
              commentRemoved: _vm.onCommentRemoved,
              commentRestored: _vm.onCommentRestored,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "top-button-wrapper" },
        [
          _c("top-button", {
            staticClass: "top-button",
            attrs: {
              id: "comments-tree-top",
              root: "#comments-tree .scroll-container",
            },
          }),
        ],
        1
      ),
      _vm.canEdit
        ? _c("comment-form", {
            ref: "form",
            staticClass: "comment-form",
            attrs: {
              "form-active": true,
              active: _vm.createFormActive,
              pending: _vm.pending,
            },
            on: {
              submitted: _vm.addComment,
              closed: function ($event) {
                _vm.createFormActive = false
              },
            },
          })
        : _vm._e(),
      _vm.canEdit
        ? _c(
            "button",
            {
              staticClass: "add-comment",
              on: {
                click: function ($event) {
                  _vm.createFormActive = true
                },
              },
            },
            [_vm._v("Написать комментарий")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }